import { useMemo } from "react";

import { merge } from "lodash";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";

import type { ThemeOptions } from "@mui/material";

import { palette } from "./palette";
import { componentsOverrides } from "./overrides";
import { customShadows } from "./custom-shadows";
import { shadows } from "./shadows";
import { typography } from "./typography";
// import { ThemeContext, ThemeContextType } from '@application/context/themeContext';
import { breakpoints } from "./breakpoints";
import { createDesignMixins } from "./mixins";

type Props = {
  children: React.ReactNode;
};

export default function CustomThemeProvider({ children }: Props) {
  // const { theme: selectedTheme } = useContext(ThemeContext) as ThemeContextType;

  const baseOption = useMemo(
    () => ({
      palette: palette("light"),
      shadows: shadows("light"),
      customShadows: customShadows("light"),
      typography,
      shape: { borderRadius: 8 },
      breakpoints,
    }),
    []
  );

  const memoizedValue: ThemeOptions = useMemo(
    () =>
      merge(
        // Base
        baseOption
      ),
    [baseOption]
  );

  const theme = createTheme(memoizedValue);

  // Design style recipes — derived from the palette above, so they stay in sync.
  theme.mixins = merge(theme.mixins, createDesignMixins(theme));

  theme.components = merge(componentsOverrides(theme));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
